import React from "react";

import { usePostContext } from "../contexts/postContext";
import { favoritesEnabled } from "../config";
import FavouriteBtn from "./favouriteBtn";

import { Button, Box, Typography } from "@mui/material";
import {
  Share as ShareIcon,
  MoreVert,
  PlayArrow,
  Check,
  Close,
} from "@mui/icons-material";

export default function CreatorOverlay(props) {
  const {
    activeGridItemActions,
    setActiveGridItemActions,
    setSharePostItem,
    setHideShare,
    setShareModalOpen,
    setActiveGridItem,
    viewRoute,
  } = usePostContext();

  const isPublished = props?.item?.status === "published" ? true : false;
  const isModified = props?.item?.status === "modified" ? true : false;

  return (
    <div
      className={`grid-item-card-creator-overlay d-flex justify-content-around align-items-center ${activeGridItemActions.id === props.id ? "open-overlay" : ""}`}
      // This overlay renders INSIDE .grid-item-card-action-area, whose onClick
      // is the card's own action — on a link that is openLink(), so pressing
      // Actions used to open the link in a new tab and then the menu. Every
      // control in here (share, view, actions, bookmark) is self-contained, so
      // nothing below should ever reach the card handler.
      onClick={(event) => event.stopPropagation()}
    >
      <div className="grid-item-card-creator-overlay-base">
        <Box className="grid-item-card-creator-overlay-id-container">
          <Typography
            variant="span"
            className="id"
            owner="admin"
            color="adminText.contrastText"
          >
            {props.id}
          </Typography>
        </Box>
        <Box className="grid-item-card-creator-overlay-status-container">
          {!isPublished && !isModified && (
            <div className="tri unpublished">
              <Close className="grid-item-card-creator-overlay-status-icon" />
            </div>
          )}

          {isModified && (
            <div className="tri modified">
              <Check className="grid-item-card-creator-overlay-status-icon" />
            </div>
          )}

          {!isModified && isPublished && (
            <div className="tri published">
              <Check className="grid-item-card-creator-overlay-status-icon" />
            </div>
          )}
        </Box>
          
        {favoritesEnabled && (
          <Box className="grid-item-card-creator-overlay-bookmark-container">
            <FavouriteBtn
              id={props.id}
              contentType={props.contentType}
              enableLabel={false}
            />
          </Box>
        )}
      </div>
      <div className="grid-item-card-creator-actions-overlay d-flex justify-content-around align-items-center">
        <Button
          className="grid-item-card-creator-action-button d-flex flex-column justify-content-center align-items-center"
          disabled={!props.item?.creatorActionsEnabled}
          onClick={() => {
            setSharePostItem(props.item);
            setHideShare(false);
            setShareModalOpen(true);
          }}
        >
          <Box className="icon-container d-flex justify-content-center align-items-center">
            <ShareIcon
              fontSize="large"
              sx={{ fill: props.item.is_share_enabled ? "#333" : "#b4b4b4" }}
            />
          </Box>
          <Typography className="grid-item-card-creator-action-button-label" variant="span" owner="admin" color="adminText.light">
            Share
          </Typography>
        </Button>
        <Button
          className="grid-item-card-creator-action-button d-flex flex-column justify-content-center align-items-center"
          onClick={() => window.open(props.viewOverride ||`${viewRoute}/${props.id}`)}
          disabled={!(isPublished || isModified)}
        >
          <Box className="icon-container d-flex justify-content-center align-items-center">
            <PlayArrow
              fontSize="large"
              sx={{ fill: props.item.isViewEnabled ? "#333" : "#b4b4b4" }}
            />
          </Box>
          <Typography className="grid-item-card-creator-action-button-label" variant="span" owner="admin" color="adminText.light">
            View
          </Typography>
        </Button>
        <Button
          className="grid-item-card-creator-action-button d-flex flex-column justify-content-center align-items-center"
          disabled={!props.item?.creatorActionsEnabled}
          onClick={(event) => {
            setActiveGridItem(props.item);
            setActiveGridItemActions({
              anchorElement: event.currentTarget,
              id: props.id,
            });
          }}
        >
          <Box className="icon-container d-flex justify-content-center align-items-center">
            <MoreVert
              fontSize="large"
              sx={{
                fill: props.item.creatorActionsEnabled ? "#333" : "#b4b4b4",
              }}
            />
          </Box>
          <Typography className="grid-item-card-creator-action-button-label" variant="span" owner="admin" color="adminText.light">
            Actions
          </Typography>
        </Button>
      </div>
    </div>
  );
}
